import type { IOrder } from '@/models/orders';
import {
  OrderAmendmentServiceApiFactory,
  OrderServiceApiFactory,
  type ModelOrderAmendmentRequest,
  type ModelOrderRequest,
  type ModelOrderResponse,
  type ModelOrderUpdateRequest,
  type OrderServiceApiOrderServiceGetManyRequest,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const orderServiceClient = () => {
  const client = createLayupClient();
  return OrderServiceApiFactory(undefined, undefined, client);
};

// This createOrder method uses the SDK
export const createOrderV2 = async (order: ModelOrderRequest) => {
  const response = await orderServiceClient().orderServiceCreate({ modelOrderRequest: order });
  return response.data;
};

// @deprecated This method does not use the SDK and has been replaced by createOrderV2
export const createOrder = async (order: Partial<IOrder> | IOrder, apiKey?: string): Promise<any> => {
  const client = createLayupClient();
  const headers = apiKey ? { apiKey } : {};
  const response = await client.post('v1/orders', order, { headers });
  return response.data;
};

export const amendOrderServiceClient = () => {
  const client = createLayupClient();
  return OrderAmendmentServiceApiFactory(undefined, undefined, client);
};

export const amendOrder = async (params: ModelOrderAmendmentRequest) => {
  const client = createLayupClient();
  const response = await client.post('v1/order-amendments', params);
  return response.data;
};

export const getOrderByIdWithPlans = async (id: string): Promise<any> => {
  const client = createLayupClient();
  const response = await client.get(`v1/orders/${id}?populate=plans`);
  return response.data;
};

export const getOrderByIdWithPlansAndPayments = async (id: string): Promise<any> => {
  const client = createLayupClient();
  const response = await client.get(`v1/orders/${id}?populate=plans,plans.payments,voucher`);
  return response.data;
};

export const getOrderByIdWithPlansPaymentsAndConnectors = async (id: string): Promise<ModelOrderResponse> => {
  const client = createLayupClient();
  const response = await client.get(`v1/orders/${id}?populate=plans,plans.payments,plans.payments.connectorData`);
  return response.data;
};

export const fetchOrders = async (request: OrderServiceApiOrderServiceGetManyRequest) => {
  const client = createLayupClient();
  const response = await OrderServiceApiFactory(undefined, undefined, client).orderServiceGetMany(request);
  return response.data;
};

export const updateOrder = async (id: string, order: ModelOrderUpdateRequest) => {
  const client = createLayupClient();
  const response = await OrderServiceApiFactory(undefined, undefined, client).orderServiceUpdate({
    id,
    modelOrderUpdateRequest: order,
  });
  return response.data;
};

export const getOrderCancellationPreviewFee = async (id: string): Promise<number> => {
  const client = createLayupClient();
  const response = await client.get(`v1/orders/${id}/previewFee`);
  return response.data;
};
